
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/permission-check",
      function () {
        return require("private-next-pages/android/local/permission-check/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/permission-check"])
      });
    }
  